import {IAttributeValue} from "../../../types/widgetFiltresTypes";
import React, {FC, Fragment, ReactNode} from "react";
import cls from "./category.module.scss";
import CustomFilterCheck from "./CustomFilterCheck";
import {TranslationsType} from "../../../types/homePageTypes";
import CustomFilterRange from "./CustomFilterRange";
import CustomFilterColor from "./CustomFilterColor";
import {ICurrencies} from "../Wrappers/MainLayout";
import {useRouter} from "next/router";

interface IWidgetFiltersProps {
    maxPrice: string;
    minPrice: string;
    filters: Array<IAttributeValue>;
    translationsData: TranslationsType;
    selectedRate: ICurrencies;
}

const WidgetFilters: FC<IWidgetFiltersProps> = (
    {
        filters,
        minPrice,
        maxPrice,
        translationsData,
        selectedRate,
    }
) => {
    const router = useRouter();
    const handleResetFilters = async () => {
        if (router.query.slug) {
            await router.push(`/catalog/${router.query.slug}`);
        } else {
            await router.push('/catalog')
        }
    };

    const handleColor_ListProps = (item: IAttributeValue) => {
        const {attribute_options, attributes: [{name = ""} = {}] = []} = item || {}
        return { data: attribute_options, value: item, title: name }
    }
    const handleFilterType: (i: IAttributeValue) => Record<string, ReactNode> = (item) => {
        return {
            list: <CustomFilterCheck {...handleColor_ListProps(item)} />,
            color: <CustomFilterColor {...handleColor_ListProps(item)} />,
            price: <CustomFilterRange
                data={{min: parseInt(minPrice), max: parseInt(maxPrice)}}
                title={item?.attributes?.[0]?.name}
                selectedRate={selectedRate}
            />
        }
    }
    return (
        <Fragment>
            {filters.map((item: IAttributeValue) => {
                const {attributes: [{code = "", filterType = ""} = {}] = [], _id} = item || {}
                return (
                    <div className={`${cls["widget-filters"]} ${cls["widget-filters--offcanvas--mobile"]}`} key={_id}>
                        <div className={`${cls["widget-filters__list"]} ${code === "color" ? `${cls["widget-filters__list-colors"]} tablet` : ""}`}>
                            {handleFilterType(item)[filterType]}
                        </div>
                        {code === "price" ? (
                            <div className={cls["widget-filters__actions"]}>
                                <button
                                    type="button"
                                    className={`btn btn-primary btn-lg ${cls["btn-widget"]}`}
                                    onClick={handleResetFilters}
                                >
                                    {translationsData?.Reset}
                                </button>
                            </div>
                        ) : <Fragment />}
                    </div>
                )
            })}
        </Fragment>
    )
}

export default WidgetFilters;
